import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum RepairEstimateRouteNames {
  REPAIR_ESTIMATE_TABLE = "REPAIR_ESTIMATE_TABLE",
  REPAIR_ESTIMATE_DETAIL = "REPAIR_ESTIMATE_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type RepairEstimate = { repairEstimateId: string };
type Query = { query?: Record<string, string> };

export class RepairEstimateGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = RepairEstimateGoToHelper.locations;

    return {
      RepairEstimateTable: (partnerId: string) => {
        return {
          text: $t("repairEstimate.repairEstimate").toString(),
          exact: true,
          to: locations.repairEstimateTable({ partnerId })
        };
      },
      RepairEstimateDetail: (partnerId: string, repairEstimateId: string) => {
        return {
          text: $t("common.nouns.detail").toString(),
          exact: true,
          to: locations.repairEstimateDetail({ partnerId, repairEstimateId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    repairEstimateTable: (d: Partner & Query) => {
      return {
        name: RepairEstimateRouteNames.REPAIR_ESTIMATE_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    repairEstimateDetail: (d: Partner & RepairEstimate & Query) => {
      return {
        name: RepairEstimateRouteNames.REPAIR_ESTIMATE_DETAIL,
        params: { partnerId: d.partnerId, repairEstimateId: d.repairEstimateId },
        query: d.query
      };
    }
  };

  goToRepairEstimateTable(d: Tab & Partner) {
    this.go(RepairEstimateGoToHelper.locations.repairEstimateTable(d), d.newTab);
  }

  goToRepairEstimateDetail(d: Tab & Partner & RepairEstimate) {
    this.go(RepairEstimateGoToHelper.locations.repairEstimateDetail(d), d.newTab);
  }
}
